import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {Check} from '@sparkware/app-utils';
import {ActiveFilter} from '../games-filter.service.interface';

export class OtherFilter implements IGameFilter {
  constructor(allAvailableFilters: {[key: string]: IGameFilter}) {

    Object.keys(allAvailableFilters).forEach(key => {
      let availableFilter = allAvailableFilters[key];
      if(availableFilter instanceof OtherFilter) {
        return;
      }

      if(availableFilter.filterType !== FilterType.categoryFilter) {
        return;
      }

      this._allOtherCategoryFilters[key] = availableFilter;

    });
  }

  private _allOtherCategoryFilters: {[key: string]: IGameFilter} = {};

  get filterType(): FilterType {
    return FilterType.categoryFilter;
  }

  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {

    let activeCategoryFiltes = currentActiveFilters.map(activeFilter => this._allOtherCategoryFilters[activeFilter.id])
                                                   .filter(filter => !Check.isNullOrUndefined(filter));

    for(let i = 0, len = activeCategoryFiltes.length; i < len; i++) {
      // if any of the other filters apply to this game then it means this game doesn't fall in to the "others" category
      if(activeCategoryFiltes[i].applyFilter(gameInfo, currentActiveFilters)) {
        return false;
      }
    }

    return true;
  }

}
